import { Injectable, inject } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import moment from 'moment';
import { DelegationSettlementDto } from 'src/app/models/dtos/delegation-settlement-dto';

@Injectable({
  providedIn: 'root',
})
export class DelegationBasicInfoFormGroupService {
  private formBuilder = inject(UntypedFormBuilder);

  constructor() {}

  buildFormGroup(isFormDisabled: boolean) {
    return this.formBuilder.group({
      fullName: [{ value: null, disabled: isFormDisabled }],
      company: [{ value: null, disabled: isFormDisabled }],
      employer: [{ value: null, disabled: isFormDisabled }],
      client: [{ value: null, disabled: isFormDisabled }],
      destinationCountry: [{ value: null, disabled: isFormDisabled }],
      organizationalUnit: [{ value: null, disabled: isFormDisabled }],
      startDate: [{ value: null, disabled: isFormDisabled }],
      endDate: [{ value: null, disabled: isFormDisabled }],
      destinationCity: [{ value: null, disabled: isFormDisabled }],
      transportType: [{ value: null, disabled: isFormDisabled }],
      delegationPurpose: [{ value: null, disabled: isFormDisabled }],
      forEmployerObject: [{ value: null, disabled: isFormDisabled }],
      pickerStartDate: [null, Validators.required],
      pickerEndDate: [null, Validators.required],
      pickerStartTime: [null, Validators.required],
      pickerEndTime: [null, Validators.required],
      pickerStartDateTime: [null],
      pickerEndDateTime: [null],
      initPickerStartDateTime: [null],
      initPickerEndDateTime: [null],
    }, { validators: this.dateValidator });
  }

  setFormGroupValue(fg: UntypedFormGroup, delegation: DelegationSettlementDto): void {
    fg.patchValue({
      fullName: delegation.FullName,
      company: delegation.CompanyName,
      employer: delegation.Employer,
      client: delegation.Client,
      organizationalUnit: delegation.OrganizationalUnit,
      destinationCountry: delegation.DestinationCountry,
      startDate: this.formatDate(delegation.StartDate),
      endDate: this.formatDate(delegation.EndDate),
      destinationCity: delegation.DestinationCity,
      transportType: delegation.TransportType,
      delegationPurpose: delegation.DelegationPurpose,
      forEmployerObject: delegation.ForEmployerObject,
      pickerStartDateTime: new Date(delegation.StartDate),
      pickerEndDateTime: new Date(delegation.EndDate),
      initPickerStartDateTime: new Date(delegation.StartDate),
      initPickerEndDateTime: new Date(delegation.EndDate),
    });

    fg.patchValue(
      {
        pickerStartDate: new Date(delegation.StartDate).resetTime(),
        pickerStartTime: delegation.StartDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        pickerEndDate: new Date(delegation.EndDate).resetTime(),
        pickerEndTime: delegation.EndDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
      },
      { emitEvent: false },
    );
  }

  private dateValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const start = control.get('pickerStartDateTime');
    const end = control.get('pickerEndDateTime');

    return start.value !== null && end.value !== null && start.value < end.value ? null : { dateValid: true };
  };

  formatDate(date: Date) {
    return moment(date).format('DD.MM.YYYY HH:mm');
  }
}
